import { baseApi } from '@/shared/api/baseApi';
import type { StockBatchDto } from '../model/types';

const stockApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listBatches: builder.query<StockBatchDto[], string>({
      query: (categoryId) => ({ url: 'stock/batches', params: { categoryId } }),
      providesTags: ['CategoryStock'],
    }),
  }),
});

export const { useListBatchesQuery } = stockApi;

export { stockApi };
